import React, { useState, useEffect } from "react";
import './Comment.css';
import Swal from 'sweetalert2';
import axios from 'axios';

const CommentList = ( { list, updatedList, userid, whenMovingNoticeDetail } ) => {
  const [commentState, setCommentState] = useState({
        'value': '',
        'update': null
    });
  const [canDeleteComments, setDeleteComments] = useState([]);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const newDeleteComments = list.reduce((acc, comment, index) => {
      if (comment.userid === userid) {
        acc.push(index);
      }
      return acc;
    }, []);
  
    setDeleteComments(newDeleteComments);
  }, [list, userid]);

  const stateChangeClick = (index) => () => {
    setCommentState({
        value: list[index].content,
        update: index
    });
   };
   
    const stateDeleteClick = (index) => async() => {
        
        const confirmationResult = await Swal.fire({
            icon: 'question',
            title: '댓글 삭제',
            text: '댓글을 삭제하시겠습니까?',
            showCancelButton: true,
            confirmButtonText: '확인',
            cancelButtonText: '취소',
            customClass: {
                popup: 'custom-swal-popup',
            }
        });
    
        if(confirmationResult.isConfirmed) {
            try {
                const response = await axios.delete(
                   list[index].links.delete.href,
                   {
                        headers: { Authorization: `Bearer ${token}` }
                   } 
                );

                if(response.status === 204) {
                    const newList = list.filter((item, i) => i !== index);
                    updatedList(newList); 
                } else {
                    await Swal.fire({
                        icon: 'error',
                        title: '실패',
                        text: '삭제 실패. 다시 시도해주세요.',
                        confirmButtonText: '확인',
                        customClass: {
                            popup: 'custom-swal-popup',
                        }
                    });
                }
            } catch(error) {
                console.error('Error deleting comment:', error);
                if(error.response) {
                    const responseData = error.response.data;
                    if(responseData) {
                        Swal.fire({
                            icon: 'error',
                            title: '댓글 삭제 오류',
                            text: responseData,
                            customClass: {
                                popup: 'custom-swal-popup',
                            }
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: '서버 응답 오류',
                            text: `서버 응답 오류: ${error.response.status}`,
                            customClass: {
                                popup: 'custom-swal-popup',
                            }
                        });
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: '서버 응답이 없습니다.',
                        text: '서버 응답이 없습니다.',
                        customClass: {
                            popup: 'custom-swal-popup',
                        }
                    });
                }
            }
        }
    }

    /* 댓글 업데이트 함수
    const inputUpdateChange = (index, e) => {
        setCommentState({
            ...commentState,
            value: e.target.value,
            update: index
        });
    };

    const updateKeyDown = (index) => (e) => {
        if(e.key != 'Enter') return;
        const newList = [...list];
        newList[index].content = commentState.value;

        setCommentState({
            ...commentState,
            update: null
        });

        updatedList(newList);
    };*/

  return (
    <div className="comment-list-container">
        <label>댓글</label>
        <span className="comments-cnt"><span>{list.length}</span> 개</span>
        <hr/>
        {list.map((comment, index) => (
            <ul key={index} className="comments-row">
                <li className="comments-id">{comment.userName}</li>
                <li className="comments-content">{comment.comments}
                    {/*commentState.update === index ? (
                        <input
                            type="text"
                            value={commentState.value}
                            className='comments-update-input'
                            onChange={(e) => inputUpdateChange(index, e)}
                            onKeyDown={updateKeyDown(index)}
                        />
                        ) : (
                            <div>
                                <span onClick={stateChangeClick(index)}>{comment.content}</span>
                                
                            </div>
                        )}*/}
                </li>
                <li className="comments-date">
                    <div>
                        <span className="date-font-style">{comment.regDate}</span>
                        {canDeleteComments.includes(index) && (<span className="comments-delete-btn" onClick={stateDeleteClick(index)}>x</span>)}
                    </div>
                </li>
            </ul>
        ))}
    </div>
  );
};

export default CommentList;
